import React, {PureComponent, ChangeEvent, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import {observer, inject} from 'mobx-react'
import cxs from 'cxs/component'
import Store from 'Store'
import {MessageType} from '../modules/UI/Model'
import Theme from 'Theme'
import {t} from 'helpers/i18n'
import {Button} from 'elements'

interface Props {
  store?: Store
}

@inject('store')
@observer
class UIMessage extends PureComponent<Props, object> {
  render() {
    const {message} = this.props.store!.UI
    if (!message) return null
    let colors
    if (message)
      colors =
        message.type === MessageType.Error
          ? Theme.color.errorBackground
          : Theme.color.warningBackground

    return (
      <Message
        type={message.type}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          textAlign: 'center',
          backgroundColor: colors,
          zIndex: 20
        }}>
        {message.text}
      </Message>
    )
  }
}

export default UIMessage

const Message = cxs('div')(
  ({type}) =>
    ({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      padding: Theme.size.space[2],
      textAlign: 'center',
      textTransform: 'none',
      whiteSpace: 'pre',
      color:
        type === MessageType.Error
          ? Theme.color.errorText
          : Theme.color.warningText,
      backgroundColor:
        type === MessageType.Error
          ? Theme.color.errorBackground
          : Theme.color.warningBackground,
      zIndex: 20,
      ':first-letter': {
        textTransform: 'uppercase'
      } as CSSProperties
    } as CSSProperties)
)

Message.propTypes = {
  type: PropTypes.string
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UIMessage.tsx